import React from "react";
import { Button } from "components/common/Button";
import GoogleIcon from "@mui/icons-material/Google";
import { getGoogleUrl } from "@/components/authentication/utils/getGoogleUrl";

interface GoogleSignInButtonProps {
  from?: string;
  invitationToken?: string | null;
}

export const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  from = "/overview",
  invitationToken,
}) => {
  const handleGoogleSignIn = () => {
    const url = getGoogleUrl(from, invitationToken);
    window.location.href = url;
  };

  return (
    <Button
      type="button"
      variant="secondary"
      size="lg"
      fullWidth={true}
      icon={<GoogleIcon className="icon-md" />}
      onClick={handleGoogleSignIn}
    >
      Continue with Google
    </Button>
  );
};
